import { render, staticRenderFns } from "./CheckFormQuery.vue?vue&type=template&id=706aa960&scoped=true"
import script from "./CheckFormQuery.vue?vue&type=script&lang=js"
export * from "./CheckFormQuery.vue?vue&type=script&lang=js"
import style0 from "./CheckFormQuery.vue?vue&type=style&index=0&id=706aa960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706aa960",
  null
  
)

export default component.exports